import Api from "../config/Axios";

// Performance Page Services
export const getPerformanceList = (token, user_id, data) => {
  const config = {headers: {Authorization: "Bearer " + (token ? token : ""), UserId: parseInt(user_id ? user_id : "")}};
  return Api.get(`api/web/rider-kpi`, {params:data, ...config});
};